import { z } from 'zod';

export const investorDeclarationGetResponseSchema = z.object({
  data: z.object({ action: z.string().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
